
import {FaGithubSquare, FaLinkedin} from 'react-icons/fa'
const Footer =()=>{
    return(
        <footer> 
            <p>Copyright &copy; {new Date().getFullYear()} Isiah Abad </p>
            <div id="footer-icons">
                <a href="https://www.linkedin.com/in/isiah-abad/" target="_blank" rel="noreferrer">
                    <FaLinkedin className='icons'/>
                </a>
                <a href="https://github.com/iabad1" target="_blank" rel="noreferrer">
                    <FaGithubSquare className='icons'/>
                </a>
            </div>
        </footer>
    )
}

export default Footer